import { render, staticRenderFns } from "./digestListCard.vue?vue&type=template&id=9c2ef562&scoped=true&"
import script from "./digestListCard.vue?vue&type=script&lang=js&"
export * from "./digestListCard.vue?vue&type=script&lang=js&"
import style0 from "./digestListCard.vue?vue&type=style&index=0&id=9c2ef562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2ef562",
  null
  
)

export default component.exports